import * as mime from 'react-native-mime-types'

import { avatarDimension, getCropString, getScaleString } from 'utils/files/fileTransformations'
import { uploadFile } from 'utils/queries'

import { SelectedFile } from 'types/file'
import { Media, MediaCrop } from 'types/media'

import { useMutation } from './useMutation'

interface UploadOptions {
  data: { crop: MediaCrop; file: SelectedFile | Media; userId: string }
}

export const useAvatarUpload = () =>
  useMutation(async (data: UploadOptions) => {
    const {
      data: { crop, file, userId },
    } = data
    if (!file) {
      throw new Error('Invalid file selected, please try again')
    }

    let fileMimeType = 'image/jpeg'
    let fileToUpload: SelectedFile | string = ''
    if ('lastModified' in file) {
      fileToUpload = file
      fileMimeType = file.type
    } else if ('url' in file) {
      fileToUpload = file.url
      fileMimeType = file.mimeType
    } else if ('base64' in file) {
      const extension = file.uri.split('.')
      fileMimeType = mime.contentType(extension[1])
      fileToUpload = `data:${fileMimeType};base64,${file.base64 || ''}`
    }

    const response = await uploadFile({
      file: fileToUpload,
      fileName: userId,
      fileType: 'image',
      transformation: `${getCropString(crop)}/${getScaleString(avatarDimension, avatarDimension)}`,
      uploadPreset: 'userAvatar',
    })

    const body = await response.json()

    return {
      crop,
      dimensions: {
        width: avatarDimension,
        height: avatarDimension,
      },
      mimeType: fileMimeType,
      url: body.secure_url,
      _original: body,
    }
  })
